import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { SettingsStorifyMeQuery } from '@custom/schema';

export function useSettingsStorifyMeQuery() {
  return useStaticQuery(graphql(SettingsStorifyMeQuery));
}
